module.exports = __webpack_public_path__ + "static/media/IMG_0357-min.256aed2a.JPG";